import React, { useEffect } from 'react';
import FormTextField from '../../../../components/FormTextField';
import { Button, Checkbox, Dialog, DialogActions, IconButton, MenuItem, Stack, Typography } from '@mui/material';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Formik, Form, FieldArray } from 'formik';
import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import appapi from '../../../../api/apiClient';
import FormSelectField from '../../../../components/FormSelectField';
import ClearIcon from '@mui/icons-material/Clear';
import FuelTypeDropdown from './FuelTypeDropdown';
import { useTranslation } from 'react-i18next';
import { initCompanyDetails } from '../../../../redux/features/authSlice';

const validationSchema = yup.object({
  shipName: yup.string('Ship Name').min(3, 'Ship Name should be atleast 3 characters').max(50, 'Maximum Character Limit 50').required(' '),
  imoNumber: yup.string('IMO Number').min(7, 'IMO Number should be atleast 7 characters').max(10, 'Maximum Character Limit of IMO Number is 10').required(' '),
  shipType: yup.string('Ship Type').required(' '),
  summerDeadWeight: yup.string('Summer Dead Weight').required(' '),
  dataOwner: yup.string('Data Owner').required(' '),
  ownerId: yup.string('Owner').required(' '),
  operatorId: yup.string('Operator').required(' '),
  chartererId: yup.string('Charterer').required(' '),
  managerId: yup.string('Manager').required(' '),
  fuel: yup
    .array('Fuel')
    .of(
      yup.object().shape({
        fuelType: yup.string().required(),
        dailyConsumptionCperPLaden: yup.number().required(),
        dailyConsumptionCperPBallest: yup.number().required(),
      }),
    )
    .min(1)
    .required(' '),
  euMrvDatabaseType: yup.string('EU MRV Database Type').required(' '),
  euMrvDatabase: yup.string('EU MRV Database'),
});

const dataBase = [
  {
    id: 1,
    name: `Verifier’s database`,
  },
  // {
  //   id: 1,
  //   name: `Vendor database (Third party database)`,
  // },
];

const dataOwnerList = [
  {
    id: 1,
    name: 'Ship Owner',
  },
  {
    id: 1,
    name: 'MRV Company',
  },
];

export default function AddShip({ modelOpen, onModelHandleClose, openRolePrivilage, type, partyInfo }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { shiptypes, shipOwners, shipMangers, operators, charterers, verifiers } = useSelector((state) => state.layout);

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const {t} = useTranslation()

  const handleAddUser = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      ...values,
      companyId: user.companyId,
      fuelType: values?.fuel?.map((item, index) => ({
        fuelType: item?.fuelType,
        emissionFactor: parseFloat(item?.emissionFactor),
        dailyConsumptionCperPLaden: parseFloat(item?.dailyConsumptionCperPLaden),
        dailyConsumptionCperPBallest: parseFloat(item?.dailyConsumptionCperPBallest),
      })),
    };
    delete payload.fuel;
    const response = await appapi.post(`/fleet`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
        dispatch(initCompanyDetails())
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };


  return (
    <Stack
      // className="!h-[100%]"
      style={{ backgroundColor: '#FFFFFF' }}
      flex={1}
    >
      <Formik
        innerRef={formRef}
        enableReinitialize={false}
        initialValues={{
          imoNumber: '',
          shipName: '',
          shipType: '',
          summerDeadWeight: '',
          dataOwner: partyInfo?.companyName,
          owner: partyInfo?.companyType === 'ship owner' ? partyInfo?.companyName : '',
          ownerId: partyInfo?.companyType === 'ship owner' ? partyInfo?._id : '',
          operator: partyInfo?.companyType === 'operator' ? partyInfo?.companyName : '',
          operatorId: partyInfo?.companyType === 'operator' ? partyInfo?._id : '',
          charterer: partyInfo?.companyType === 'charterer' ? partyInfo?.companyName : '',
          chartererId: partyInfo?.companyType === 'charterer' ? partyInfo?._id : '',
          manager: partyInfo?.companyType === 'ship manager' ? partyInfo?.companyName : '',
          managerId: partyInfo?.companyType === 'ship manager' ? partyInfo?._id : '',
          fuelType: [],
          euMrvDatabaseType: '',
          euMrvDatabase: '',
          fuel: [],
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleAddUser(values);
        }}
      >
        {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, setFieldTouched }) => (
          <Form
            className="flex flex-col flex-1"
            autoComplete="off"
          >
            <Stack
              flexGrow={1}
              className="relative"
            >
              <Stack className="flex-overflow">
                <Stack
                  style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                  className="m-[15px] p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-16"
                    color={text}
                  >
                    {t('Ship Information')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                    color={textLight}
                  >
                    {t('Some info may be visible to other people using ZeroEmission services')}
                  </Typography>
                  <Stack>
                    <FormTextField
                      outlineLabel={t('IMO no')}
                      name="imoNumber"
                      requiredMark={true}
                      whiteSpace={true}
                      inputProps={{ maxLength: 11 }}
                      onlyNumber={true}
                    />
                  </Stack>
                  <Stack>
                    <FormTextField
                      outlineLabel={t('Ship name')}
                      name="shipName"
                      requiredMark={true}
                      whiteSpace={true}
                      inputProps={{ maxLength: 51 }}
                    />
                  </Stack>
                  <Stack>
                    <FormSelectField
                      name="shipType"
                      label={t('Ship type') + ' *'}
                    >
                      {shiptypes?.length === 0 && (
                        <MenuItem
                          disabled
                          value=""
                        >
                          <em>{t('No Data Found')}</em>
                        </MenuItem>
                      )}
                      {shiptypes?.map((item) => (
                        <MenuItem
                          key={item.shipType}
                          value={item.shipType}
                        >
                          <div style={{ textTransform: 'capitalize' }}>{item.shipType}</div>
                        </MenuItem>
                      ))}
                    </FormSelectField>
                  </Stack>
                  <Stack>
                    <FormTextField
                      outlineLabel={t('Summer deadweight')}
                      name="summerDeadWeight"
                      requiredMark={true}
                      onlyFloat={true}
                      whiteSpace={true}
                    />
                  </Stack>
                  <Stack>
                    <FuelTypeDropdown
                      onDone={(fuelUsed) => {
                        
                        const arr = fuelUsed.map(res => {
                          const already = values?.fuel?.find( f => f.fuelType === res.fuelType); 
                          if(already) {
                            return already;
                          }

                          return res;
                        });
                        setFieldValue('fuel', arr);
                      }}
                      slectedTypes={values?.fuel?.map((res) => res.fuelType)}
                    />
                  </Stack>

                  <FieldArray
                    name="fuel"
                    render={(arrayHelpers) => (
                      <>
                        {values?.fuel?.map((item, index) => (
                          <Stack style={{marginTop: index > 0 ? '16px' : '0px'}}>
                            <Stack
                              direction={'row'}
                              // alignItems={'center'}
                              justifyContent={'space-between'}
                            >
                              <Stack>
                                <Typography
                                  className="fw-medium ff-Roboto fs-14"
                                  color={text}
                                >
                                  {item?.fuelType}
                                </Typography>
                                <Typography
                                  className="fw-regular ff-Roboto fs-12"
                                  color={text}
                                  style={{marginBottom: '14px'}}
                                >
                                 {t('Emission factor')} {item?.emissionFactor} t CO2/ t fuel
                                </Typography>
                              </Stack>
                              <IconButton
                                onClick={() => {
                                  arrayHelpers.remove(index);
                                }}
                              >
                                <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
                              </IconButton>
                            </Stack>
                            <Stack direction={'row'} justifyContent={'space-between'} >
                              <Stack flex={1}>
                                <FormTextField
                                  sx={{ mt: 0 }}
                                  name={`fuel[${index}].dailyConsumptionCperPLaden`}
                                  outlineLabel={t('Daily consumption C/P Laden') + ' *'}
                                  onlyFloat={true}

                                />
                              </Stack>
                              <Stack sx={{width: '16px'}} />
                              <Stack flex={1}>
                                <FormTextField
                                  sx={{ mt: 0 }}
                                  name={`fuel[${index}].dailyConsumptionCperPBallest`}
                                  outlineLabel={t('Daily consumption C/P Ballast') + ' *'}
                                  onlyFloat={true}

                                />
                              </Stack>
                            </Stack>
                            <Stack
                              style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
                              className="!mr-[16px]"
                            />
                          </Stack>
                        ))}
                      </>
                    )}
                  />
                </Stack>
                <Stack
                  style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                  className="m-[15px] p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-16 !capitalize"
                    color={text}
                  >
                    {t('Database information')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                    color={textLight}
                  >
                    {t('Some info may be visible to other people using ZeroEmission services')}
                  </Typography>
                  <Stack>
                    {/* <FormSelectField
                      name="dataOwner"
                      label={'Data owner *'}
                      disabled={true}
                    >
                      {dataOwnerList?.length === 0 && (
                        <MenuItem
                          disabled
                          value=""
                        >
                          <em>No Data Found</em>
                        </MenuItem>
                      )}
                      {dataOwnerList?.map((item) => (
                        <MenuItem
                          key={item.name}
                          value={item.name}
                        >
                          <div style={{ textTransform: 'capitalize' }}>{item.name}</div>
                        </MenuItem>
                      ))}
                    </FormSelectField> */}
                    <FormTextField
                      outlineLabel={t('Data owner')}
                      name="dataOwner"
                      requiredMark={true}
                      whiteSpace={true}
                      inputProps={{ maxLength: 51 }}
                      disabled={true}
                    />
                  </Stack>
                  <Stack>
                    <FormSelectField
                      name="euMrvDatabaseType"
                      label={t('EU ETS Verifier') + ' *'}
                    >
                      {dataBase?.length === 0 && (
                        <MenuItem
                          disabled
                          value=""
                        >
                          <em>{t('No Data Found')}</em>
                        </MenuItem>
                      )}
                      {dataBase?.map((item) => (
                        <MenuItem
                          key={item.name}
                          value={item.name}
                        >
                          <div style={{ textTransform: 'capitalize' }}>{t(item.name)}</div>
                        </MenuItem>
                      ))}
                    </FormSelectField>
                  </Stack>
                  {values?.euMrvDatabaseType === `Verifier’s database` && (
                    <Stack>
                      <FormSelectField
                        name="euMrvDatabase"
                        label={t('Verifier Database List') + ' *'}
                      >
                        {verifiers?.length === 0 && (
                          <MenuItem
                            disabled
                            value=""
                          >
                            <em>{t('No Data Found')}</em>
                          </MenuItem>
                        )}
                        {verifiers?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                          >
                            <div style={{ textTransform: 'capitalize' }}>{item.verifierName}</div>
                          </MenuItem>
                        ))}
                      </FormSelectField>
                    </Stack>
                  )}
                </Stack>
                <Stack
                  style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                  className="m-[15px] p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-16 !capitalize"
                    color={text}
                  >
                    {t('Party information')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                    color={textLight}
                  >
                    {t('Some info may be visible to other people using ZeroEmission services')}
                  </Typography>
                  <Stack>
                    {partyInfo?.companyType === 'ship owner' ? (
                      <FormTextField
                        outlineLabel={t('Owner')}
                        name="owner"
                        requiredMark={true}
                        onlyNumber={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 51 }}
                        disabled={true}
                      />
                    ) : (
                      <FormSelectField
                        name="ownerId"
                        label={t('Owner') + ' *'}
                        onSelect={(id) => {
                          const name = shipOwners?.filter((res) => res._id == id)[0]?.companyName;
                          setFieldValue('owner', name || '');
                        }}
                      >
                        {shipOwners?.length === 0 && (
                          <MenuItem
                            disabled
                            value=""
                          >
                            <em>{t('No Data Found')}</em>
                          </MenuItem>
                        )}
                        {shipOwners?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                          >
                            <div style={{ textTransform: 'capitalize' }}>{item.companyName}</div>
                          </MenuItem>
                        ))}
                      </FormSelectField>
                    )}
                  </Stack>
                  <Stack>
                    {partyInfo?.companyType === 'ship manager' ? (
                      <FormTextField
                        outlineLabel={t('MRV company')}
                        name="manager"
                        requiredMark={true}
                        onlyNumber={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 51 }}
                        disabled={true}
                      />
                    ) : (
                      <FormSelectField
                        name="managerId"
                        label={t('MRV company') + ' *'}
                        onSelect={(id) => {
                          const name = shipMangers?.filter((res) => res._id == id)[0]?.companyName;
                          setFieldValue('manager', name || '');
                        }}
                      >
                        {shipMangers?.length === 0 && (
                          <MenuItem
                            disabled
                            value=""
                          >
                            <em>{t('No Data Found')}</em>
                          </MenuItem>
                        )}
                        {shipMangers?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                          >
                            <div style={{ textTransform: 'capitalize' }}>{item.companyName}</div>
                          </MenuItem>
                        ))}
                      </FormSelectField>
                    )}
                  </Stack>
                  <Stack>
                    {partyInfo?.companyType === 'charterer' ? (
                      <FormTextField
                        outlineLabel={t('Charterer')}
                        name="charterer"
                        requiredMark={true}
                        onlyNumber={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 51 }}
                        disabled={true}
                      />
                    ) : (
                      <FormSelectField
                        name="chartererId"
                        label={t('Charterer') + ' *'}
                        // onSelect={(e) => setFieldValue(charterer, e)}
                        onSelect={(id) => {
                          const name = charterers?.filter((res) => res._id == id)[0]?.companyName;
                          setFieldValue('charterer', name || '');
                        }}
                      >
                        {charterers?.length === 0 && (
                          <MenuItem
                            disabled
                            value=""
                          >
                            <em>{t('No Data Found')}</em>
                          </MenuItem>
                        )}
                        {charterers?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                          >
                            <div style={{ textTransform: 'capitalize' }}>{item.companyName}</div>
                          </MenuItem>
                        ))}
                      </FormSelectField>
                    )}
                  </Stack>
                  <Stack>
                    {partyInfo?.companyType === 'operator' ? (
                      <FormTextField
                        outlineLabel={t('Operator')}
                        name="operator"
                        requiredMark={true}
                        onlyNumber={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 51 }}
                        disabled={true}
                      />
                    ) : (
                      <FormSelectField
                        name="operatorId"
                        label={t('Operator') + ' *'}
                        onSelect={(id) => {
                          const name = operators?.filter((res) => res._id == id)[0]?.companyName;
                          setFieldValue('operator', name || '');
                        }}
                      >
                        {operators?.length === 0 && (
                          <MenuItem
                            disabled
                            value=""
                          >
                            <em>{t('No Data Found')}</em>
                          </MenuItem>
                        )}
                        {operators?.map((item) => (
                          <MenuItem
                            key={item._id}
                            value={item._id}
                          >
                            <div style={{ textTransform: 'capitalize' }}>{item.companyName}</div>
                          </MenuItem>
                        ))}
                      </FormSelectField>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              direction="row"
              justifyContent="flex-end"
              className="px-4 py-2"
              style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
            >
              <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                      // borderColor: theme.palette.secondary.main,
                    },
                  },
                ]}
                style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                onClick={() => {
                  onModelHandleClose(false);
                }}
              >
                {t('Close')}
              </Button>
              <Button
                sx={[
                  buttonStyle2,
                  {
                    color: theme.palette.background.main,
                    backgroundColor: theme.palette.primary.dark,
                    textTransform:"uppercase",
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                    },
                  },
                ]}
                style={{ width: '128px', height: '40px' }}
                disabled={!(dirty && isValid) || (values?.euMrvDatabaseType === `Verifier’s database` && values?.euMrvDatabase === '')}
                type="submit"
                variant="contained"
              >
                {t('Finish')}
              </Button>
            </Stack>
          </Form>
        )}
      </Formik>
    </Stack>
  );
}
